import React from 'react';
import { Box } from "rebass";
import ReactPlayer from "react-player";
const fallbackText = 'Your browser does not support the video element';

const VideoPlayer = ({ src, fallback = fallbackText, active, sx, playsinline, ...props }) => {
	return src ? (
		<Box
			{...props}
			sx={{ ...sx, position: 'relative', overflow: 'hidden' }}
		>
			<ReactPlayer url={src} playing={active} muted={true} playsinline={!!playsinline} volume={0.5} width={"100%"} height={"100%"} controls />
		</Box>
	) : null
};

export default VideoPlayer